<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="Dedication-ded"><span epub:type="pagebreak" id="pg_v" title="v"><span class="ePub-I">Dedicated to John F. X. Harbison, and all the happy memories we shared. I’ll be loving you always.</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3623fe5d